import nBossConnection from 'modules/base/service/nBossConnection';

class OptimizerService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'optimizerControl';
	}

	/**
	 * @return {Promise<NamedDto[]>}
	 */
	getListSelection() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/getListSelection`)
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	addDefaultOptimizers() {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/addDefaultOptimizers`, {})
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}
}

export default new OptimizerService();